import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { fadeInRightAnimation } from "src/@fury/animations/fade-in-right.animation";
import { fadeInUpAnimation } from "src/@fury/animations/fade-in-up.animation";
import { scaleInAnimation } from "src/@fury/animations/scale-in.animation";
import { Subject } from "rxjs";
import { CommonService } from "src/app/services/common.service";

@Component({
  selector: "fury-file-claim-history",
  templateUrl: "./file-claim-history.component.html",
  styleUrls: ["./file-claim-history.component.scss"],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation],
})
export class FileClaimHistoryComponent implements OnInit, OnDestroy {
  ngUnsubscribe = new Subject<void>();

  displayedColumns: string[] = ["assignee", "role", "assignedBy", "assignedOn"];

  constructor(
    public commonService: CommonService,
    public dialogRef: MatDialogRef<FileClaimHistoryComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { claimHistory: any; fileClaimId: string }
  ) {}

  ngOnInit(): void {}

  cancel(): void {
    this.dialogRef.close();
  }
  
  close() {
    this.dialogRef.close();
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
